import { render, staticRenderFns } from "./UserInitialsAvatar.vue?vue&type=template&id=a7d30afa"
import script from "./UserInitialsAvatar.vue?vue&type=script&lang=js"
export * from "./UserInitialsAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports